import * as THREE from 'three';

/** Chaff canister — warm brass body, dark band, spark tip. */
const BODY = 0xc9a227;
const BAND = 0x5d4037;
const TIP = 0xffe082;
const FUSE = 0xff8f00;

/**
 * Compact defensive pod. Local +Z is nose-forward before orientation.
 * Does no damage; fuse + burst handled by ArcadeGame.
 */
export function createChaff(): THREE.Group {
  const pod = new THREE.Group();
  pod.name = 'arcade-chaff';

  const bodyMat = new THREE.MeshBasicMaterial({ color: BODY });
  const bandMat = new THREE.MeshBasicMaterial({ color: BAND });
  const tipMat = new THREE.MeshBasicMaterial({ color: TIP });
  const fuseMat = new THREE.MeshBasicMaterial({ color: FUSE });

  const body = new THREE.Mesh(new THREE.BoxGeometry(0.28, 0.28, 0.72), bodyMat);
  pod.add(body);

  const band = new THREE.Mesh(new THREE.BoxGeometry(0.32, 0.32, 0.14), bandMat);
  band.position.z = -0.12;
  pod.add(band);

  const tip = new THREE.Mesh(new THREE.BoxGeometry(0.2, 0.2, 0.22), tipMat);
  tip.position.z = 0.42;
  pod.add(tip);

  const fuse = new THREE.Mesh(new THREE.BoxGeometry(0.08, 0.08, 0.28), fuseMat);
  fuse.position.z = -0.52;
  pod.add(fuse);

  // Small collision radius for the flying canister (burst uses a separate radius)
  pod.userData.radius = 0.7;
  return pod;
}
